<app-page-header title="O-Ring Reference Guides" subtitle="Explore O-Ring Design and Technical Information."
  image="url(assets/site/images/general-header19.webp)"></app-page-header>


<div id="content" class="container">

  <p>Our o-ring design guides offer technical selection and design information based on industry and application uses to
    help learn the best fit for your sealing application. Custom o-rings are typically available with no tooling fees
    and rush delivery options. </p>

  <h3>Reference Guides</h3>
  <ul class="responsive-grid-list">
    <li><a [routerLink]="['/o-ring-seal-product-index.htm']">Product Index</a></li>
    <li><a [routerLink]="['/o-ring-material-selection-comparison.htm']">O-Ring Material Selection</a></li>
    <li><a [routerLink]="['/o-ring-size-chart-index.htm']">O-Ring Sizing Charts - X-Ring Square-Ring Dimensions</a></li>
    <li><a [routerLink]="['/o-ring-groove-design-directory.htm']">O-Ring Groove Design</a></li>
    <li><a [routerLink]="['/o-ring-chemical-compatibility-chart.htm']">Fluid Compatibility Guide</a></li>
    <li><a [routerLink]="['/o-ring-failure.htm']">O-Ring Failure Analysis</a></li>
    <li><a [routerLink]="['/o-ring-permeation.htm']">O-Ring Permeation</a></li>
    <li><a [routerLink]="['/o-ring-kits-accessories.htm']">O-Ring Accessories</a></li>
    <li><a [routerLink]="['/o-ring-mil-specs-chart.htm']">Mil-Spec Chart</a></li>
    <li><a [routerLink]="['/quality-systems.htm']">Quality Systems</a></li>
    <li><a [routerLink]="['/inquiry-quote.htm']">Engineering Support</a></li>
    <li><a [routerLink]="['/o-ring-shelf-life.htm']">O-Ring Shelf Life</a></li>
    <li><a [routerLink]="['/parker-o-rings.htm']">Parker O-Ring Materials</a></li>
    <li><a [routerLink]="['/o-ring-tolerance-index.htm']">Molded Rubber and O-Ring Tolerance Charts</a></li>
    <li><a [routerLink]="['/medical-o-rings.htm']">Rubber and O-Ring Compliance Standards (FDA, USP, NSF, 3A, UL,
        ASTM)</a></li>
    <li><a [routerLink]="['/o-ring-mil-specs-chart.htm']">Aerospace and Military Specification Reference Guide (MIL, MS,
        AMS, AS, SAE...)</a></li>
  </ul>
  <h3>Industry References</h3>
  <ul class="responsive-grid-list">
    <li> <a [routerLink]="['/semiconductor-o-rings.htm']"> Semiconductor - Solar - LCD </a> </li>
    <li> <a [routerLink]="['/cpi.htm']"> Chemical Processing - Handling CPI</a> </li>
    <li> <a [routerLink]="['/high-pressure-o-rings.htm']"> High Pressure O-Rings </a> </li>
    <li> <a [routerLink]="['/medical-o-rings.htm']"> Medical - Pharmaceutical - Life Science </a> </li>
    <li> <a [routerLink]="['/metal-detectable-o-rings-sanitary-gaskets.htm']">Metal Detectable Food - Pharmaceutical
      </a></li>
    <li> <a [routerLink]="['/fda-o-rings-food-grade.htm']">FDA Food - Human Contact </a> </li>
    <li> <a [routerLink]="['/nsf-o-rings-drinking-water.htm']">NSF Drinking Water - Irrigation </a> </li>
    <li> <a [routerLink]="['/3a-o-rings-dairy.htm']">3A USDA Dairy Processing </a> </li>
    <li> <a [routerLink]="['/emi-o-rings.htm']">EMI Shielding Conductive O-Rings - Ohmerics&reg; </a> </li>
    <li> <a [routerLink]="['/o-ring-mil-specs-chart.htm']"> Aerospace - Military - Auto </a> </li>
  </ul>
  <h3>Application References</h3>
  <ul class="responsive-grid-list">
    <li> <a [routerLink]="['/markez-o-rings.htm']">High Temperature O-Rings </a> </li>
    <li> <a [routerLink]="['/o-ring-material-selection-comparison.htm']">Low Temperature O-Rings</a> </li>
    <li> <a [routerLink]="['/markez-o-rings.htm']">Chemical Resistant O-Rings </a> </li>
    <li> <a [routerLink]="['/high-pressure-o-rings.htm']">High Pressure O-Rings</a> </li>
  </ul>
</div>

<app-cta-full-width></app-cta-full-width>